module.exports = __webpack_public_path__ + "components/flag/static/square/tz-dd5086d3e64d747b150a93e6a51ba2f5.svg";